import { DialogService } from "@/service/DialogService";
import { Permission, Role } from "@/types/Permissions";
import { Ref, ref, computed } from "vue";
import { SweetAlertResult } from 'sweetalert2';
import { PermissionRolesService } from "@/service/PermissionService";

/*
 * 初期処理
 */
export function usePermissionRoles() {
  const permissions: Ref<Permission[] | null> = ref(null) // 権限一覧
  const roles: Ref<Role[] | null> = ref(null) // ロール一覧
  const selectedRolePermissions: Ref<Permission[]> = ref([]) // ロールに対して設定する権限配列
  const srv = new PermissionRolesService()

  // ロール一覧と権限一覧の取得
  const getAllOptions = async () => {
    const req = await srv.getAllOptions();
    permissions.value = req.permissions
    roles.value = req.roles
  }

  // 指定したロールが持つ権限を取得
  const getPermissionsByRoleId = async (roleId: number) => {
    const res = await srv.getPermissionsByRoleId(roleId);
    selectedRolePermissions.value = res
  }

  const hasPermission = (perm: Permission) => {
    const find = selectedRolePermissions.value.find(rolePerm => rolePerm.mst_permission_id === perm.mst_permission_id);
    return find ? true : false
  }

  const switchPermission = (perm: Permission) => {
    hasPermission(perm) ? removePermission(perm) : setPermission(perm)
  }

  // アクセス権の付与
  const setPermission = (perm: Permission) => {
    if (hasPermission(perm)) {
      return
    }

    selectedRolePermissions.value.push(perm)
  }

  // アクセス権の剥奪
  const removePermission = (perm: Permission) => {
    const findIndex = selectedRolePermissions.value.findIndex(rolePerm => rolePerm.mst_permission_id === perm.mst_permission_id)
    if (findIndex < 0) {
      return
    }
    selectedRolePermissions.value.splice(findIndex, 1)
  }

  // ロールに対する権限の保存
  const isSaving = ref(false)
  const savePermissionForRole = async (roleId: number | null) => {
    if (!roleId) {
      return
    }

    DialogService.question({
      text: '権限を変更しますか？（変更により期待しない動作が起こるおそれが可能性があります）',
      showCancelButton: true,
      confirmButtonText: '変更する',
      cancelButtonText: 'キャンセル',

    }).then(async (result: SweetAlertResult) => {
      if (result.isConfirmed) {
        isSaving.value = true
        if (await srv.save(roleId, selectedRolePermissions.value)) {
          await DialogService.success({
            title: '権限を設定しました'
          })
          await getPermissionsByRoleId(roleId)
        }
        isSaving.value = false
      }
    })
  }


  return {
    permissions,
    roles,
    selectedRolePermissions,
    getRoleAndPermissionOptions: getAllOptions,
    getPermissionsByRoleId,
    savePermissionForRole,
    hasPermission,
    switchPermission,
    setPermission,
    isSaving
  }
}
